export const isValidObject = (obj) => {
    if (!obj) return false
    if (typeof obj !== 'object') return false
    if (Array.isArray(obj)) return false
    if (Object.keys(obj).length === 0) return false
    return true
}
